import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import LibraryForm from './LibraryForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditLibraryScreen() {
  const { id } = useParams();

  const api = Api.LibraryContent.useReadItemAsAdmin(id ?? '');

  if (!api.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Library Content"
          items={[{ name: 'Library Content', url: '/library' }]}
        />

        <LibraryForm existing={api.data} />
      </Stack>
    </ScreenWrap>
  );
}
